import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http, errMsg, DEFAULT_SETTINGS } from "@/lib/api";
import { FieldInput } from "./FieldInput";

const FIELDS = [
  { key: "whatsapp", label: "WhatsApp (DDD + número)" },
  { key: "instagram", label: "Instagram (sem @)" },
  { key: "pix_key", label: "Chave Pix (CNPJ)" },
  { key: "pix_holder", label: "Titular do Pix (nome no banco)" },
  { key: "pix_city", label: "Cidade do titular (usada no QR Code)" },
  { key: "email", label: "E-mail de contato" },
];

export const SettingsForm = () => {
  const [form, setForm] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    http.get("/admin/settings").then((r) => setForm({ ...DEFAULT_SETTINGS, ...(r.data || {}) })).catch(() => {});
  }, []);
  const save = async () => {
    try {
      await http.put("/admin/settings", form);
      toast.success("Configurações salvas!");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="max-w-lg space-y-4" data-testid="admin-settings-form">
      {FIELDS.map((f) => (
        <div key={f.key} className="space-y-1.5">
          <label className="text-xs uppercase tracking-wider text-teal-300">{f.label}</label>
          <FieldInput f={f} value={form[f.key]} onChange={(v) => setForm({ ...form, [f.key]: v })} />
        </div>
      ))}
      <button onClick={save} data-testid="admin-settings-save" className="rounded-full bg-[#2DD4BF] px-6 py-3 font-semibold text-[#041214]">Salvar configurações</button>
    </div>
  );
};
